import { NgModule } from '@angular/core';
import { NavbarComponent } from './navbar.component';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';


@NgModule({
    imports: [
        AngularFontAwesomeModule,
        RouterModule,
        CommonModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [
      NavbarComponent
    ],
  
    declarations: [
        NavbarComponent
    ],
    providers: [
      
    ],
    entryComponents: [
        NavbarComponent,
    ],
  
  })
  export class NavbarModule { }

  // required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }